import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {RouteBuilder} from '@util/route-builder';
import {HeaderComponent} from '@app/header/header.component';
import {GoBackDirective} from '@util/directives/go-back.directive';
import {MarkantElementsModule} from '@markant/elements-angular';
import {ToolbarComponent} from '@app/toolbar/toolbar.component';

@Component({
  selector: 'app-terms-of-use',
  templateUrl: './terms-of-use.component.html',
  styleUrls: ['./terms-of-use.component.scss'],
  standalone: true,
  imports: [RouterModule, HeaderComponent, GoBackDirective, MarkantElementsModule, ToolbarComponent],
})
export class TermsOfUseComponent {
  get privacyRoute(): string {
    return RouteBuilder.privacy().build();
  }
}
